/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {internalUpdateCategoryNotificationSettings} from '../api'

export const useMutationInternalUpdateCategoryNotificationSettings = createReactQueryMutationHook('internalUpdateCategoryNotificationSettings', internalUpdateCategoryNotificationSettings)
